import { Expose } from 'class-transformer';

import { SnModel } from '@lib/common/models';

export class AxonDeviceLocationModel extends SnModel {
  @Expose()
  public accuracy: number;

  @Expose()
  public isValid: boolean;

  @Expose()
  public latitude: number;

  @Expose()
  public longitude: number;

  @Expose()
  public timestamp: number;

  constructor(data: any = {}) {
    super();
    this.fromJSON(data);
  }
}
